__webpack_require__.p = "/admin-template-v3/";